const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditPenLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.608 2.39203L4.60325 9.39675C4.00556 9.99444 3.70672 10.2933 3.45499 10.627C3.23144 10.9233 3.03586 11.2398 2.87079 11.5723C2.68492 11.9466 2.55129 12.3476 2.28402 13.1495L2.00081 13.9992L2.99203 13.6164L2.99205 13.6164C3.69924 13.3433 4.05284 13.2068 4.38369 13.0288C4.67756 12.8707 4.95773 12.6884 5.22129 12.4837C5.518 12.2532 5.78603 11.9852 6.32209 11.4491L13.4936 4.27765C14.0143 3.75695 14.0143 2.91273 13.4936 2.39203C12.9729 1.87133 12.1287 1.87133 11.608 2.39203Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M6.43725 11.334L4.66602 11.334L4.66602 9.33398",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPenLight);
export default __webpack_public_path__ + "static/media/icon_edit_pen_light.4566fa5cd69b275a7cbeff804f476de4.svg";
export { ForwardRef as ReactComponent };